// ** Redux
import { createAsyncThunk } from "@reduxjs/toolkit";

// ** Helpers
import { createApiCall } from "helpers/createApiCall";

// ############################################################

export const getUserProfileFriends = createAsyncThunk(
	"user-profile/friends/getUserProfileFriends",
	createApiCall(
		async (
			{ userId, login, isAuth, page, sex, infinityScroll = false },
			client
		) => {
			const response = await client.get(
				`/friend${isAuth ? "" : "/unauthorized"}`,
				{
					params: {
						login,
						id: userId,
						page: page || 1,
						sex: sex || "any",
						sort: "asc",
						limit: 30,
						is_main: 1,
					},
				}
			);

			return {
				...response.data,
				counters: response.counters,
				infinityScroll,
			};
		}
	)
);

// ############################################################
